// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"monument"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M15 6V16H9V6L8 3H16L15 6Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M16 19H18V22H6V19H8V16H16V19Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M15 6H9M15 6V16H9V6M15 6L16 3V2M9 6L8 3V2M8.5 3H15.5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M16 19V16H8V19M16 19H8M16 19H18V22H6V19H8","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const MonumentIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'monument',
    ref,
    icon: element,
  },
));

MonumentIcon.displayName = 'MonumentIcon';

export default MonumentIcon;
